export enum BeneficiaryType{
    AssetManager = "Asset Manager" ,
    Fund = "Fund",
    DecisionMaker = "Decision Maker"
}